import AuthTokenRepositoryImpl from './impl/AuthTokenRepositoryImpl'

export default {
  getInstance () {
    return new AuthTokenRepositoryImpl()
  }
}
